import React from 'react'
import IconTxtBtnArrow from '../../../../../img/icon-txt-btn-arrow.svg';

/**
 * 
 * @param {string} [url] - The url to link to the audio page
 */
function AudioPageLink({url, text = 'Course Materials'}) {

    
    // Component level JSX return statement ******************************************************
    return (
        <a className="text-btn-arrow"  href={url}>{text}<span className="link-arrow"><IconTxtBtnArrow/></span></a>
    )
}
export default AudioPageLink;